import { createSelector } from "reselect";

const cpKkmListSelector = state => state.cp.kkmList;

export const isLoadingSelector = createSelector(
	cpKkmListSelector,
	state => state.isLoading
);
export const isNoItemsSelector = createSelector(
	cpKkmListSelector,
	state => state.isNoItems
);
export const scrollSelector = createSelector(
	cpKkmListSelector,
	state => state.scroll
);
export const searchSelector = createSelector(
	cpKkmListSelector,
	state => state.search
);
export const itemsSelector = createSelector(
	cpKkmListSelector,
	state => state.items
);
